import { InvoiceConfigBankAccount } from 'store/invoice-config/types';

export enum PaymentMethods {
    BANK_TRANSFER = 'BANK_TRANSFER',
    PAY_PAL = 'PAY_PAL',
}

export type InvoiceTemplateFormFields = {
    standardTerms: string | null;
    paymentLink: string | null;
    paymentNotes: string | null;
    bankAccount: InvoiceConfigBankAccount[];
};

export type PaypalPaymentMethod = {
    paymentMethod: PaymentMethods.PAY_PAL;
    url: string;
};

export type PaymentMethod = InvoiceConfigBankAccount | PaypalPaymentMethod;
